import { render, staticRenderFns } from "./BaixarPdf.vue?vue&type=template&id=542c8a50&scoped=true&"
import script from "./BaixarPdf.vue?vue&type=script&lang=js&"
export * from "./BaixarPdf.vue?vue&type=script&lang=js&"
import style0 from "./BaixarPdf.vue?vue&type=style&index=0&id=542c8a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c8a50",
  null
  
)

export default component.exports